import {
  DatasourceUpgradeDiff,
  DatasourceUpgradeFieldStatus,
  DatasourceUpgradeStepDiff,
} from '../datasourceUpgrade.types';
import { setAutoloaderText } from './autoloader/datasourceUpgradeAutoloaderHelper';
import { filterNulls } from '@/utils/filterNulls';

export const getBronzeChanges = (diff: DatasourceUpgradeDiff | undefined) => {
  return filterNulls([
    diff?.spec.autoloader.format,
    diff?.spec.autoloader.schemaFile,
    diff?.spec.autoloader.cloudFiles.schemaHintsFile,
    diff?.spec.autoloader.cloudFiles.schemaHints,
  ]).filter((q) => q.status !== 'unchanged');
};

export const setBronzeText = (state: DatasourceUpgradeDiff) => {
  setAutoloaderText(state);
};

export const queryBronzeChanges = (
  bronze: DatasourceUpgradeStepDiff,
  query: { status?: DatasourceUpgradeFieldStatus } = {},
) => {
  return bronze.changes.filter(
    (q) => !query?.status || q.status === query.status,
  );
};
